import React from 'react';
import cx from 'classnames';

import PackageIcon from '~/components/cart/package-icon';
import ShipmentItemsList from '~/components/shipments/shipment-items-list';
import {
  WeedWarriorCard,
  WeedWarriorCta,
} from '~/components/shipments/weed-warrior-components';
import { subscriptionType } from '~/features/subscriptions/subscription';
import { centsToCurrency } from '~/utils/numbers';

import styles from '~/components/shipments/shipment.module.scss';

const Shipment = ({
  shipment,
  panelHeaderContent,
  size,
  showProductDetailsModal,
  showPrice,
  id,
  faqContent,
  showAltTooltip,
  titleOverride,
  showWeedProductVariant,
}) => {
  let type = null;
  if (shipment.isPestPlanShipment) {
    type = subscriptionType.PEST;
  } else if (shipment.isLawnPlanShipment) {
    type = subscriptionType.LAWN_PLAN;
  }

  let title = shipment.boxNumber ? (
    <span>Box {shipment.boxNumber}</span>
  ) : (
    'add-ons box'
  );

  if (titleOverride) {
    title = titleOverride;
  }

  const showWeedProduct = showWeedProductVariant && shipment.boxNumber === 1;

  return (
    <div className={cx('panel', styles.shipmentPanel)} id={id}>
      <div className={styles.panelHeading}>
        <PackageIcon className={styles.shipmentBoxIcon} category={type} />

        <span className={styles.boxNumber} id={`${id}-title`}>
          {title}
        </span>

        {showPrice && (
          <span className={styles.shipmentPrice} id={`${id}-price`}>
            {centsToCurrency(shipment.subtotal)}
          </span>
        )}

        {panelHeaderContent}
        {shipment?.boxDescription && (
          <p className={styles.boxDescription}>{shipment.boxDescription}</p>
        )}
      </div>

      {showWeedProduct && (
        <div className={styles.productWrapperMobile}>
          <WeedWarriorCard />
          <WeedWarriorCta />
        </div>
      )}

      <ShipmentItemsList
        shipmentItems={shipment.shipmentItems}
        size={size}
        showProductDetailsModal={showProductDetailsModal}
        faqContent={faqContent}
        showAltTooltip={showAltTooltip}
        showWeedProduct={showWeedProduct}
      />
    </div>
  );
};

export default Shipment;
